export const generatedResearchPackageManifest = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-research-package-manifest",
  "operatingRule": "Customer-facing research packages must include package hash, included artifact hashes, workspace gates, run hashes, allowed use, and blockers.",
  "packageCount": 3,
  "blockedPackageCount": 3,
  "customerContractCount": 3,
  "customerReadyPackageCount": 0,
  "blockedCustomerContractCount": 3,
  "commercialUseAllowed": false,
  "packages": [
    {
      "id": "package-investor-feasibility-brief-v1",
      "title": "Investor Feasibility Brief Package",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "status": "beta-blocked",
      "deliverableType": "paid-beta-feasibility-intelligence",
      "customerQuestion": "Given current public evidence, which off-world industrial scenario is most plausible and what would need to change the ranking?",
      "buyerFit": [
        "deep-tech investors",
        "strategic foresight teams",
        "aerospace concept teams"
      ],
      "workspaceRef": {
        "id": "workspace-investor-feasibility-brief",
        "title": "Investor Feasibility Brief",
        "workspaceHash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035",
        "reviewStage": "beta-review",
        "blockedGateCount": 2
      },
      "runRefs": [
        {
          "id": "run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "selectedScenarioId": "hybrid",
          "claimState": "model-derived-unvalidated"
        },
        {
          "id": "run-conservative-moon-first-2026-06-19",
          "label": "Conservative Moon-first stress run",
          "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
          "selectedScenarioId": "moon-first",
          "claimState": "model-derived-unvalidated"
        }
      ],
      "includedArtifacts": [
        {
          "id": "artifact-scenario-diligence-work-order-ledger",
          "label": "Scenario diligence work-order ledger",
          "path": "public/scenario-diligence-work-order-ledger.json",
          "hash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
          "role": "Customer/package-linked diligence work orders, acceptance gates, affected scenarios, replay commands, and decision-delta requirements."
        },
        {
          "id": "artifact-scenario-decision-delta-ledger",
          "label": "Scenario decision delta ledger",
          "path": "public/scenario-decision-delta-ledger.json",
          "hash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
          "role": "Fail-closed before/after acceptance records proving no diligence work order can change a customer answer without a hashed after-run artifact."
        },
        {
          "id": "artifact-customer-decision-dossier-ledger",
          "label": "Customer decision dossier ledger",
          "path": "public/customer-decision-dossier-ledger.json",
          "hash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
          "role": "Scenario-by-scenario customer-use state, buyer boundary, evidence summary, blockers, proof-to-change-answer, and next proof actions."
        },
        {
          "id": "artifact-model-validation-protocols",
          "label": "Model validation protocol ledger",
          "path": "public/model-validation-protocols.json",
          "hash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "role": "Domain-by-domain validation protocols, acceptance criteria, source/runtime gates, blocker states, and commercial-use boundaries."
        },
        {
          "id": "artifact-asteroid-candidate-evidence-ledger",
          "label": "Asteroid candidate evidence ledger",
          "path": "public/asteroid-candidate-evidence-ledger.json",
          "hash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "role": "Candidate-level SBDB/CAD/MPC/taxonomy/spectra evidence requirements, blockers, and resource-promotion gates."
        },
        {
          "id": "artifact-candidate-source-promotion-ledger",
          "label": "Candidate source promotion ledger",
          "path": "public/candidate-source-promotion-ledger.json",
          "hash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
          "role": "Candidate work-order source custody, resource-promotion, customer-use gates, report intake state, and explicit work-order gaps."
        },
        {
          "id": "artifact-candidate-source-closure-packets",
          "label": "Candidate source closure packets",
          "path": "public/candidate-source-closure-packets.json",
          "hash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "role": "Executable candidate-by-candidate closure packets with missing MPC, review, composition, and customer-use acceptance gates."
        },
        {
          "id": "artifact-capability-maturity-ledger",
          "label": "Capability maturity ledger",
          "path": "public/capability-maturity-ledger.json",
          "hash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
          "role": "Business capability maturity, source coverage, model coverage, sidecar blockers, and commercialization gates."
        },
        {
          "id": "artifact-claim-evidence-ledger",
          "label": "Claim evidence ledger",
          "path": "public/claim-evidence-ledger.json",
          "hash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
          "role": "Claim-level source coverage, confidence, promotion gates, allowed use, and blockers."
        },
        {
          "id": "artifact-feasibility-report",
          "label": "Canonical feasibility report",
          "path": "public/feasibility-report.json",
          "hash": "fnv1a32-5b0df6f9",
          "role": "Executive scenario comparison and governance summary."
        },
        {
          "id": "artifact-model-run-ledger",
          "label": "Versioned model-run ledger",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
          "role": "Reproducible run inputs, uncertainty settings, rankings, and run hashes."
        },
        {
          "id": "artifact-model-run-comparison-ledger",
          "label": "Model-run comparison ledger",
          "path": "public/model-run-comparison-ledger.json",
          "hash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
          "role": "Run-to-run selected-scenario, rank-one, utility, uncertainty, business-readiness, and replay-boundary deltas."
        },
        {
          "id": "artifact-assumption-impact-ledger",
          "label": "Assumption impact ledger",
          "path": "public/assumption-impact-ledger.json",
          "hash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "role": "Assumption-to-scenario sensitivity, source coverage, stress behavior, and promotion gates."
        },
        {
          "id": "artifact-scenario-comparison-board",
          "label": "Scenario comparison board",
          "path": "public/scenario-comparison-board.json",
          "hash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
          "role": "Business-grade scenario comparison board with decision score, uncertainty budget, economics, traceability, blockers, and CSV/Markdown export hashes."
        },
        {
          "id": "artifact-scenario-notebook-pack",
          "label": "Scenario notebook pack",
          "path": "public/scenario-notebook-pack.json",
          "hash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
          "role": "Scenario-by-scenario reviewer notebooks with source coverage, open questions, blockers, work orders, and Markdown export hashes."
        },
        {
          "id": "artifact-runtime-validation-campaign-ledger",
          "label": "Runtime validation campaign ledger",
          "path": "public/runtime-validation-campaign-ledger.json",
          "hash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
          "role": "Campaign-by-campaign runtime closure plan for SPICE, Orekit, GMAT, Tudat, and OpenMDAO/Dymos evidence promotion."
        },
        {
          "id": "artifact-runtime-closure-packet",
          "label": "Runtime closure packet",
          "path": "public/runtime-closure-packet.json",
          "hash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
          "role": "Operator-grade runtime closure packet with setup custody, commands, intake reports, acceptance checks, and fail-closed release impact."
        },
        {
          "id": "artifact-trajectory-validation-matrix",
          "label": "Trajectory validation matrix",
          "path": "public/trajectory-validation-matrix.json",
          "hash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
          "role": "Decision-facing SPICE/Orekit/GMAT/Tudat validation matrix with current evidence state, independent-comparison requirements, residual frontier blockers, and scenario decision links."
        },
        {
          "id": "artifact-trajectory-residual-acceptance-ledger",
          "label": "Trajectory residual acceptance ledger",
          "path": "public/trajectory-residual-acceptance-ledger.json",
          "hash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
          "role": "Fail-closed cross-tool residual acceptance lanes for Orekit/GMAT/Tudat/SPICE comparisons before trajectory evidence can affect scenario rankings."
        },
        {
          "id": "artifact-source-use-clearance-dossier",
          "label": "Source-use clearance dossier",
          "path": "public/source-use-clearance-dossier.json",
          "hash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
          "role": "Customer/commercial source-use clearance workflow by source class, required approvals, redistribution boundaries, and fail-closed report-use decisions."
        },
        {
          "id": "artifact-scenario-decision-audit-ledger",
          "label": "Scenario decision audit ledger",
          "path": "public/scenario-decision-audit-ledger.json",
          "hash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
          "role": "Scenario-by-scenario explanation of ranking drivers, flip conditions, assumption sensitivities, validation protocol refs, and proof burdens."
        },
        {
          "id": "artifact-scenario-crossover-frontier",
          "label": "Scenario crossover frontier",
          "path": "public/scenario-crossover-frontier.json",
          "hash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
          "role": "Pairwise scenario utility gaps and explicit threshold paths showing what assumptions would need to change for a challenger scenario to win."
        },
        {
          "id": "artifact-scenario-uncertainty-budget-ledger",
          "label": "Scenario uncertainty budget ledger",
          "path": "public/scenario-uncertainty-budget-ledger.json",
          "hash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
          "role": "Scenario-by-scenario decomposition of modeled uncertainty, assumption blockers, runtime gaps, source-use risk, economics evidence, and resource ambiguity."
        },
        {
          "id": "artifact-scenario-decision-ledger",
          "label": "Scenario decision ledger",
          "path": "public/scenario-decision-ledger.json",
          "hash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "role": "Weighted driver decomposition, uncertainty, economics, blockers, and decision lane for every scenario."
        },
        {
          "id": "artifact-scenario-traceability-matrix",
          "label": "Scenario traceability matrix",
          "path": "public/scenario-traceability-matrix.json",
          "hash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
          "role": "Scenario-by-scenario trace from rankings to assumptions, claims, sources, model runs, runtime sidecars, and blockers."
        },
        {
          "id": "artifact-evidence-gap-priority-ledger",
          "label": "Evidence gap priority ledger",
          "path": "public/evidence-gap-priority-ledger.json",
          "hash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
          "role": "Ranked closure backlog for source, runtime, economics, resource, traceability, and release evidence gaps."
        },
        {
          "id": "artifact-promotion-closure-ledger",
          "label": "Promotion closure ledger",
          "path": "public/promotion-closure-ledger.json",
          "hash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
          "role": "Executable closure plans for blocked science, resource, economics, materials, and model-validation promotion gates."
        },
        {
          "id": "artifact-economics-frontier",
          "label": "Economics frontier report",
          "path": "public/economics-frontier.json",
          "hash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
          "role": "Seeded economics Monte Carlo, rank stability, funding coverage, and promotion blockers."
        },
        {
          "id": "artifact-economics-evidence-ledger",
          "label": "Economics evidence ledger",
          "path": "public/economics-evidence-ledger.json",
          "hash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "role": "Dated economics source surfaces, normalization requirements, model input references, and promotion gates."
        },
        {
          "id": "artifact-materials-process-evidence-ledger",
          "label": "Materials/process evidence ledger",
          "path": "public/materials-process-evidence-ledger.json",
          "hash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "role": "Process-by-process material property requirements, source references, scenario fit links, runtime artifact gaps, and promotion gates."
        },
        {
          "id": "artifact-space-environment-evidence-ledger",
          "label": "Space environment evidence ledger",
          "path": "public/space-environment-evidence-ledger.json",
          "hash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
          "role": "SPDF/CDAWeb, CCMC, SWPC, DTN, and CCSDS source requirements, scenario stress links, runtime artifact gaps, and promotion gates."
        },
        {
          "id": "artifact-sidecar-readiness-ledger",
          "label": "Runtime sidecar readiness ledger",
          "path": "public/sidecar-readiness-ledger.json",
          "hash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "role": "Contract-by-contract runtime readiness, promoted artifacts, blocked prerequisites, preflight evidence, command templates, and next actions."
        },
        {
          "id": "artifact-workspace-ledger",
          "label": "Research workspace ledger",
          "path": "public/workspace-ledger.json",
          "hash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
          "role": "Project/workspace binding for runs, claims, assumptions, notebooks, and review gates."
        },
        {
          "id": "artifact-model-artifacts",
          "label": "Model artifact bundle",
          "path": "public/model-artifacts.json",
          "hash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "role": "Source-backed model artifact records and promotion blockers."
        },
        {
          "id": "artifact-source-refresh",
          "label": "Source refresh evidence report",
          "path": "public/source-refresh-report.json",
          "hash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "role": "Snapshot-first source refresh plan and review candidate checks."
        },
        {
          "id": "artifact-source-ingestion-ledger",
          "label": "Source ingestion work-order ledger",
          "path": "public/source-ingestion-ledger.json",
          "hash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
          "role": "Source-by-source ingestion contracts, required payload hashes, normalization gates, and promotion blockers."
        },
        {
          "id": "artifact-source-use-rights-ledger",
          "label": "Source use-rights ledger",
          "path": "public/source-use-rights-ledger.json",
          "hash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "role": "Source-by-source terms, citation, redistribution, provider-endorsement, and customer-use review gates."
        },
        {
          "id": "artifact-source-use-review-packets",
          "label": "Source use review packets",
          "path": "public/source-use-review-packets.json",
          "hash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
          "role": "Per-source review packets for terms/license capture, citation approval, redistribution decisions, provider-endorsement boundaries, and customer-use approval."
        },
        {
          "id": "artifact-source-query-custody-ledger",
          "label": "Source query custody ledger",
          "path": "public/source-query-custody-ledger.json",
          "hash": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
          "role": "Provider query contracts, parser boundaries, unit maps, uncertainty maps, legal notes, and non-promotion rules for live source refresh candidates."
        },
        {
          "id": "artifact-sidecar-validation",
          "label": "Science sidecar validation gate",
          "path": "public/sidecar-validation-report.json",
          "hash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "role": "Fail-closed intake gate for SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts."
        },
        {
          "id": "artifact-sidecar-work-orders",
          "label": "Science sidecar execution packet",
          "path": "public/sidecar-work-orders.json",
          "hash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
          "role": "Executable work orders for external SPICE/Orekit/GMAT/Tudat/OpenMDAO workers."
        },
        {
          "id": "artifact-sidecar-run-specs",
          "label": "Science sidecar run specifications",
          "path": "public/sidecar-run-specs.json",
          "hash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
          "role": "Hash-backed execution specs, required inputs, acceptance gates, and non-evidence boundaries for external science workers."
        },
        {
          "id": "artifact-sidecar-artifact-templates",
          "label": "Science sidecar artifact templates",
          "path": "public/sidecar-artifact-templates.json",
          "hash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
          "role": "Fail-closed JSON templates showing the exact output shape external science workers must fill before sidecar intake."
        },
        {
          "id": "artifact-sidecar-scaffold-rejection-ledger",
          "label": "Science sidecar scaffold rejection ledger",
          "path": "public/sidecar-scaffold-rejection-ledger.json",
          "hash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
          "role": "Hash-backed proof that Orekit, GMAT, and Tudat beta scaffolds are contract-traceable and intentionally blocked from promotion."
        },
        {
          "id": "workspace-workspace-investor-feasibility-brief",
          "label": "Investor Feasibility Brief",
          "path": "public/workspace-ledger.json",
          "hash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035",
          "role": "Workspace-specific project, decision gate, review gates, and evidence hashes."
        },
        {
          "id": "run-run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "role": "Model run selected scenario: hybrid."
        },
        {
          "id": "run-run-conservative-moon-first-2026-06-19",
          "label": "Conservative Moon-first stress run",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
          "role": "Model run selected scenario: moon-first."
        }
      ],
      "customerReadinessContract": {
        "state": "customer-beta-blocked",
        "decisionSupportAllowed": true,
        "commercialUseAllowed": false,
        "verifiedClaimIds": [
          "claim-mercury-flux",
          "claim-de440-boundary",
          "claim-dtn"
        ],
        "blockedClaimIds": [
          "claim-helium3",
          "claim-spf-separation",
          "claim-mercury-core"
        ],
        "allowedClaims": [
          "Source-backed beta context claims may be cited only with evidence hashes attached.",
          "Scenario rankings may be used as decision-support heuristics with uncertainty and blocker context visible.",
          "Evidence-gap, crossover, and diligence priorities may be used to scope paid research work."
        ],
        "blockedClaims": [
          "No operational mission design, launch commitment, or flight-dynamics certification.",
          "No asteroid or planetary resource-composition claim without candidate-specific taxonomy, spectra, mission, or sample evidence.",
          "No commercial economics, throughput, process-quality, or manufacturability claim while economics/materials/process ledgers are blocked.",
          "No customer-facing trajectory/event-window claim until the full required runtime set and independent validation gates pass.",
          "No raw source redistribution or customer commercial use until source-use rights review passes."
        ],
        "proofGates": [
          {
            "id": "source-use-rights",
            "label": "Source use rights",
            "status": "blocked",
            "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source."
          },
          {
            "id": "runtime-sidecars",
            "label": "Runtime sidecars",
            "status": "blocked",
            "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
            "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight."
          },
          {
            "id": "model-validation",
            "label": "Model validation",
            "status": "blocked",
            "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
            "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval."
          },
          {
            "id": "resource-candidates",
            "label": "Resource candidates",
            "status": "blocked",
            "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
            "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim."
          },
          {
            "id": "economics",
            "label": "Economics evidence",
            "status": "blocked",
            "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
            "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads."
          },
          {
            "id": "materials-process",
            "label": "Materials/process evidence",
            "status": "blocked",
            "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
            "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts."
          },
          {
            "id": "workspace-review",
            "label": "Workspace review",
            "status": "blocked",
            "evidenceHash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035",
            "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed."
          }
        ],
        "blockedProofGateIds": [
          "source-use-rights",
          "runtime-sidecars",
          "model-validation",
          "resource-candidates",
          "economics",
          "materials-process",
          "workspace-review"
        ],
        "currentRuntimePreflight": {
          "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
          "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
          "readyContractIds": [
            "openmdao-dymos-optimization-v1",
            "spice-gf-event-window-v1"
          ],
          "blockedContractIds": [
            "gmat-transfer-v1",
            "orekit-propagation-v1",
            "tudat-transfer-v1"
          ]
        },
        "customerUseBoundary": "This package can support research planning and diligence only; it is not commercial proof until every proof gate is pass.",
        "contractHash": "sha256-f56b586ab243bb595075fe4fabd8d9a828a3dbfd2a9569ad6e7320b61389b6f3"
      },
      "evidenceHashes": {
        "feasibilityReport": "fnv1a32-5b0df6f9",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
        "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
        "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
        "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
        "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "spaceEnvironmentEvidenceLedger": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
        "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
        "sourceQueryCustodyLedger": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
        "customerReadinessContract": "sha256-f56b586ab243bb595075fe4fabd8d9a828a3dbfd2a9569ad6e7320b61389b6f3",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "sidecarScaffoldRejectionLedger": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
        "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
        "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
        "includedArtifacts": "sha256-64ab60f11af2e3951f3a8aa565f22a1efef15adc624603d7e0f63d6daa7b03d2"
      },
      "reviewRequired": [
        "owner approval",
        "source review",
        "visual/UI review"
      ],
      "blockers": [
        "Claim promotion safe: 1 workspace claims remain unverified or blocked.",
        "Runtime sidecar validation: No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted.",
        "No runtime sidecar artifact has promoted; mission-design claims remain blocked.",
        "Customer readiness proof gate is blocked: source-use-rights.",
        "Customer readiness proof gate is blocked: runtime-sidecars.",
        "Customer readiness proof gate is blocked: model-validation.",
        "Customer readiness proof gate is blocked: resource-candidates.",
        "Customer readiness proof gate is blocked: economics.",
        "Customer readiness proof gate is blocked: materials-process.",
        "Customer readiness proof gate is blocked: workspace-review.",
        "Model validation protocols still have blocked commercial-use gates.",
        "Materials/process records still lack promoted material payloads and runtime physics artifacts."
      ],
      "allowedUse": "Decision-support and diligence package only; not an operational mission design, launch commitment, or verified resource claim.",
      "packageHash": "sha256-8709add4b60e61a1e7e3f71c9339a266bddac45e4528d51bfcf643e9fcfa1ad3"
    },
    {
      "id": "package-asteroid-feedstock-screen-v1",
      "title": "Asteroid Feedstock Screen Package",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "status": "beta-blocked",
      "deliverableType": "source-gap-and-scenario-screen",
      "customerQuestion": "Which asteroid/feedstock assumptions are most fragile, and which legal public data would make a candidate worth deeper study?",
      "buyerFit": [
        "space resources startups",
        "university labs",
        "aerospace research teams"
      ],
      "workspaceRef": {
        "id": "workspace-asteroid-feedstock-screen",
        "title": "Asteroid Feedstock Screen",
        "workspaceHash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709",
        "reviewStage": "blocked-by-source-depth",
        "blockedGateCount": 2
      },
      "runRefs": [
        {
          "id": "run-asteroid-feedstock-probe-2026-06-19",
          "label": "Asteroid feedstock uncertainty probe",
          "runHash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
          "selectedScenarioId": "asteroid-first",
          "claimState": "model-derived-unvalidated"
        },
        {
          "id": "run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "selectedScenarioId": "hybrid",
          "claimState": "model-derived-unvalidated"
        }
      ],
      "includedArtifacts": [
        {
          "id": "artifact-scenario-diligence-work-order-ledger",
          "label": "Scenario diligence work-order ledger",
          "path": "public/scenario-diligence-work-order-ledger.json",
          "hash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
          "role": "Customer/package-linked diligence work orders, acceptance gates, affected scenarios, replay commands, and decision-delta requirements."
        },
        {
          "id": "artifact-scenario-decision-delta-ledger",
          "label": "Scenario decision delta ledger",
          "path": "public/scenario-decision-delta-ledger.json",
          "hash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
          "role": "Fail-closed before/after acceptance records proving no diligence work order can change a customer answer without a hashed after-run artifact."
        },
        {
          "id": "artifact-customer-decision-dossier-ledger",
          "label": "Customer decision dossier ledger",
          "path": "public/customer-decision-dossier-ledger.json",
          "hash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
          "role": "Scenario-by-scenario customer-use state, buyer boundary, evidence summary, blockers, proof-to-change-answer, and next proof actions."
        },
        {
          "id": "artifact-model-validation-protocols",
          "label": "Model validation protocol ledger",
          "path": "public/model-validation-protocols.json",
          "hash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "role": "Domain-by-domain validation protocols, acceptance criteria, source/runtime gates, blocker states, and commercial-use boundaries."
        },
        {
          "id": "artifact-asteroid-candidate-evidence-ledger",
          "label": "Asteroid candidate evidence ledger",
          "path": "public/asteroid-candidate-evidence-ledger.json",
          "hash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "role": "Candidate-level SBDB/CAD/MPC/taxonomy/spectra evidence requirements, blockers, and resource-promotion gates."
        },
        {
          "id": "artifact-candidate-source-promotion-ledger",
          "label": "Candidate source promotion ledger",
          "path": "public/candidate-source-promotion-ledger.json",
          "hash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
          "role": "Candidate work-order source custody, resource-promotion, customer-use gates, report intake state, and explicit work-order gaps."
        },
        {
          "id": "artifact-candidate-source-closure-packets",
          "label": "Candidate source closure packets",
          "path": "public/candidate-source-closure-packets.json",
          "hash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "role": "Executable candidate-by-candidate closure packets with missing MPC, review, composition, and customer-use acceptance gates."
        },
        {
          "id": "artifact-capability-maturity-ledger",
          "label": "Capability maturity ledger",
          "path": "public/capability-maturity-ledger.json",
          "hash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
          "role": "Business capability maturity, source coverage, model coverage, sidecar blockers, and commercialization gates."
        },
        {
          "id": "artifact-claim-evidence-ledger",
          "label": "Claim evidence ledger",
          "path": "public/claim-evidence-ledger.json",
          "hash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
          "role": "Claim-level source coverage, confidence, promotion gates, allowed use, and blockers."
        },
        {
          "id": "artifact-feasibility-report",
          "label": "Canonical feasibility report",
          "path": "public/feasibility-report.json",
          "hash": "fnv1a32-5b0df6f9",
          "role": "Executive scenario comparison and governance summary."
        },
        {
          "id": "artifact-model-run-ledger",
          "label": "Versioned model-run ledger",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
          "role": "Reproducible run inputs, uncertainty settings, rankings, and run hashes."
        },
        {
          "id": "artifact-model-run-comparison-ledger",
          "label": "Model-run comparison ledger",
          "path": "public/model-run-comparison-ledger.json",
          "hash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
          "role": "Run-to-run selected-scenario, rank-one, utility, uncertainty, business-readiness, and replay-boundary deltas."
        },
        {
          "id": "artifact-assumption-impact-ledger",
          "label": "Assumption impact ledger",
          "path": "public/assumption-impact-ledger.json",
          "hash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "role": "Assumption-to-scenario sensitivity, source coverage, stress behavior, and promotion gates."
        },
        {
          "id": "artifact-scenario-comparison-board",
          "label": "Scenario comparison board",
          "path": "public/scenario-comparison-board.json",
          "hash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
          "role": "Business-grade scenario comparison board with decision score, uncertainty budget, economics, traceability, blockers, and CSV/Markdown export hashes."
        },
        {
          "id": "artifact-scenario-notebook-pack",
          "label": "Scenario notebook pack",
          "path": "public/scenario-notebook-pack.json",
          "hash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
          "role": "Scenario-by-scenario reviewer notebooks with source coverage, open questions, blockers, work orders, and Markdown export hashes."
        },
        {
          "id": "artifact-runtime-validation-campaign-ledger",
          "label": "Runtime validation campaign ledger",
          "path": "public/runtime-validation-campaign-ledger.json",
          "hash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
          "role": "Campaign-by-campaign runtime closure plan for SPICE, Orekit, GMAT, Tudat, and OpenMDAO/Dymos evidence promotion."
        },
        {
          "id": "artifact-runtime-closure-packet",
          "label": "Runtime closure packet",
          "path": "public/runtime-closure-packet.json",
          "hash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
          "role": "Operator-grade runtime closure packet with setup custody, commands, intake reports, acceptance checks, and fail-closed release impact."
        },
        {
          "id": "artifact-trajectory-validation-matrix",
          "label": "Trajectory validation matrix",
          "path": "public/trajectory-validation-matrix.json",
          "hash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
          "role": "Decision-facing SPICE/Orekit/GMAT/Tudat validation matrix with current evidence state, independent-comparison requirements, residual frontier blockers, and scenario decision links."
        },
        {
          "id": "artifact-trajectory-residual-acceptance-ledger",
          "label": "Trajectory residual acceptance ledger",
          "path": "public/trajectory-residual-acceptance-ledger.json",
          "hash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
          "role": "Fail-closed cross-tool residual acceptance lanes for Orekit/GMAT/Tudat/SPICE comparisons before trajectory evidence can affect scenario rankings."
        },
        {
          "id": "artifact-source-use-clearance-dossier",
          "label": "Source-use clearance dossier",
          "path": "public/source-use-clearance-dossier.json",
          "hash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
          "role": "Customer/commercial source-use clearance workflow by source class, required approvals, redistribution boundaries, and fail-closed report-use decisions."
        },
        {
          "id": "artifact-scenario-decision-audit-ledger",
          "label": "Scenario decision audit ledger",
          "path": "public/scenario-decision-audit-ledger.json",
          "hash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
          "role": "Scenario-by-scenario explanation of ranking drivers, flip conditions, assumption sensitivities, validation protocol refs, and proof burdens."
        },
        {
          "id": "artifact-scenario-crossover-frontier",
          "label": "Scenario crossover frontier",
          "path": "public/scenario-crossover-frontier.json",
          "hash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
          "role": "Pairwise scenario utility gaps and explicit threshold paths showing what assumptions would need to change for a challenger scenario to win."
        },
        {
          "id": "artifact-scenario-uncertainty-budget-ledger",
          "label": "Scenario uncertainty budget ledger",
          "path": "public/scenario-uncertainty-budget-ledger.json",
          "hash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
          "role": "Scenario-by-scenario decomposition of modeled uncertainty, assumption blockers, runtime gaps, source-use risk, economics evidence, and resource ambiguity."
        },
        {
          "id": "artifact-scenario-decision-ledger",
          "label": "Scenario decision ledger",
          "path": "public/scenario-decision-ledger.json",
          "hash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "role": "Weighted driver decomposition, uncertainty, economics, blockers, and decision lane for every scenario."
        },
        {
          "id": "artifact-scenario-traceability-matrix",
          "label": "Scenario traceability matrix",
          "path": "public/scenario-traceability-matrix.json",
          "hash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
          "role": "Scenario-by-scenario trace from rankings to assumptions, claims, sources, model runs, runtime sidecars, and blockers."
        },
        {
          "id": "artifact-evidence-gap-priority-ledger",
          "label": "Evidence gap priority ledger",
          "path": "public/evidence-gap-priority-ledger.json",
          "hash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
          "role": "Ranked closure backlog for source, runtime, economics, resource, traceability, and release evidence gaps."
        },
        {
          "id": "artifact-promotion-closure-ledger",
          "label": "Promotion closure ledger",
          "path": "public/promotion-closure-ledger.json",
          "hash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
          "role": "Executable closure plans for blocked science, resource, economics, materials, and model-validation promotion gates."
        },
        {
          "id": "artifact-economics-frontier",
          "label": "Economics frontier report",
          "path": "public/economics-frontier.json",
          "hash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
          "role": "Seeded economics Monte Carlo, rank stability, funding coverage, and promotion blockers."
        },
        {
          "id": "artifact-economics-evidence-ledger",
          "label": "Economics evidence ledger",
          "path": "public/economics-evidence-ledger.json",
          "hash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "role": "Dated economics source surfaces, normalization requirements, model input references, and promotion gates."
        },
        {
          "id": "artifact-materials-process-evidence-ledger",
          "label": "Materials/process evidence ledger",
          "path": "public/materials-process-evidence-ledger.json",
          "hash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "role": "Process-by-process material property requirements, source references, scenario fit links, runtime artifact gaps, and promotion gates."
        },
        {
          "id": "artifact-space-environment-evidence-ledger",
          "label": "Space environment evidence ledger",
          "path": "public/space-environment-evidence-ledger.json",
          "hash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
          "role": "SPDF/CDAWeb, CCMC, SWPC, DTN, and CCSDS source requirements, scenario stress links, runtime artifact gaps, and promotion gates."
        },
        {
          "id": "artifact-sidecar-readiness-ledger",
          "label": "Runtime sidecar readiness ledger",
          "path": "public/sidecar-readiness-ledger.json",
          "hash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "role": "Contract-by-contract runtime readiness, promoted artifacts, blocked prerequisites, preflight evidence, command templates, and next actions."
        },
        {
          "id": "artifact-workspace-ledger",
          "label": "Research workspace ledger",
          "path": "public/workspace-ledger.json",
          "hash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
          "role": "Project/workspace binding for runs, claims, assumptions, notebooks, and review gates."
        },
        {
          "id": "artifact-model-artifacts",
          "label": "Model artifact bundle",
          "path": "public/model-artifacts.json",
          "hash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "role": "Source-backed model artifact records and promotion blockers."
        },
        {
          "id": "artifact-source-refresh",
          "label": "Source refresh evidence report",
          "path": "public/source-refresh-report.json",
          "hash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "role": "Snapshot-first source refresh plan and review candidate checks."
        },
        {
          "id": "artifact-source-ingestion-ledger",
          "label": "Source ingestion work-order ledger",
          "path": "public/source-ingestion-ledger.json",
          "hash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
          "role": "Source-by-source ingestion contracts, required payload hashes, normalization gates, and promotion blockers."
        },
        {
          "id": "artifact-source-use-rights-ledger",
          "label": "Source use-rights ledger",
          "path": "public/source-use-rights-ledger.json",
          "hash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "role": "Source-by-source terms, citation, redistribution, provider-endorsement, and customer-use review gates."
        },
        {
          "id": "artifact-source-use-review-packets",
          "label": "Source use review packets",
          "path": "public/source-use-review-packets.json",
          "hash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
          "role": "Per-source review packets for terms/license capture, citation approval, redistribution decisions, provider-endorsement boundaries, and customer-use approval."
        },
        {
          "id": "artifact-source-query-custody-ledger",
          "label": "Source query custody ledger",
          "path": "public/source-query-custody-ledger.json",
          "hash": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
          "role": "Provider query contracts, parser boundaries, unit maps, uncertainty maps, legal notes, and non-promotion rules for live source refresh candidates."
        },
        {
          "id": "artifact-sidecar-validation",
          "label": "Science sidecar validation gate",
          "path": "public/sidecar-validation-report.json",
          "hash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "role": "Fail-closed intake gate for SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts."
        },
        {
          "id": "artifact-sidecar-work-orders",
          "label": "Science sidecar execution packet",
          "path": "public/sidecar-work-orders.json",
          "hash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
          "role": "Executable work orders for external SPICE/Orekit/GMAT/Tudat/OpenMDAO workers."
        },
        {
          "id": "artifact-sidecar-run-specs",
          "label": "Science sidecar run specifications",
          "path": "public/sidecar-run-specs.json",
          "hash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
          "role": "Hash-backed execution specs, required inputs, acceptance gates, and non-evidence boundaries for external science workers."
        },
        {
          "id": "artifact-sidecar-artifact-templates",
          "label": "Science sidecar artifact templates",
          "path": "public/sidecar-artifact-templates.json",
          "hash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
          "role": "Fail-closed JSON templates showing the exact output shape external science workers must fill before sidecar intake."
        },
        {
          "id": "artifact-sidecar-scaffold-rejection-ledger",
          "label": "Science sidecar scaffold rejection ledger",
          "path": "public/sidecar-scaffold-rejection-ledger.json",
          "hash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
          "role": "Hash-backed proof that Orekit, GMAT, and Tudat beta scaffolds are contract-traceable and intentionally blocked from promotion."
        },
        {
          "id": "workspace-workspace-asteroid-feedstock-screen",
          "label": "Asteroid Feedstock Screen",
          "path": "public/workspace-ledger.json",
          "hash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709",
          "role": "Workspace-specific project, decision gate, review gates, and evidence hashes."
        },
        {
          "id": "run-run-asteroid-feedstock-probe-2026-06-19",
          "label": "Asteroid feedstock uncertainty probe",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
          "role": "Model run selected scenario: asteroid-first."
        },
        {
          "id": "run-run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "role": "Model run selected scenario: hybrid."
        }
      ],
      "customerReadinessContract": {
        "state": "customer-beta-blocked",
        "decisionSupportAllowed": true,
        "commercialUseAllowed": false,
        "verifiedClaimIds": [
          "claim-mercury-flux",
          "claim-de440-boundary",
          "claim-dtn"
        ],
        "blockedClaimIds": [
          "claim-helium3",
          "claim-spf-separation",
          "claim-mercury-core"
        ],
        "allowedClaims": [
          "Source-backed beta context claims may be cited only with evidence hashes attached.",
          "Scenario rankings may be used as decision-support heuristics with uncertainty and blocker context visible.",
          "Evidence-gap, crossover, and diligence priorities may be used to scope paid research work."
        ],
        "blockedClaims": [
          "No operational mission design, launch commitment, or flight-dynamics certification.",
          "No asteroid or planetary resource-composition claim without candidate-specific taxonomy, spectra, mission, or sample evidence.",
          "No commercial economics, throughput, process-quality, or manufacturability claim while economics/materials/process ledgers are blocked.",
          "No customer-facing trajectory/event-window claim until the full required runtime set and independent validation gates pass.",
          "No raw source redistribution or customer commercial use until source-use rights review passes."
        ],
        "proofGates": [
          {
            "id": "source-use-rights",
            "label": "Source use rights",
            "status": "blocked",
            "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source."
          },
          {
            "id": "runtime-sidecars",
            "label": "Runtime sidecars",
            "status": "blocked",
            "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
            "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight."
          },
          {
            "id": "model-validation",
            "label": "Model validation",
            "status": "blocked",
            "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
            "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval."
          },
          {
            "id": "resource-candidates",
            "label": "Resource candidates",
            "status": "blocked",
            "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
            "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim."
          },
          {
            "id": "economics",
            "label": "Economics evidence",
            "status": "blocked",
            "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
            "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads."
          },
          {
            "id": "materials-process",
            "label": "Materials/process evidence",
            "status": "blocked",
            "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
            "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts."
          },
          {
            "id": "workspace-review",
            "label": "Workspace review",
            "status": "blocked",
            "evidenceHash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709",
            "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed."
          }
        ],
        "blockedProofGateIds": [
          "source-use-rights",
          "runtime-sidecars",
          "model-validation",
          "resource-candidates",
          "economics",
          "materials-process",
          "workspace-review"
        ],
        "currentRuntimePreflight": {
          "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
          "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
          "readyContractIds": [
            "openmdao-dymos-optimization-v1",
            "spice-gf-event-window-v1"
          ],
          "blockedContractIds": [
            "gmat-transfer-v1",
            "orekit-propagation-v1",
            "tudat-transfer-v1"
          ]
        },
        "customerUseBoundary": "This package can support research planning and diligence only; it is not commercial proof until every proof gate is pass.",
        "contractHash": "sha256-af2fd31db2e74998866192ad6e50e6f6f113fa06c30f185583d9ca527451472f"
      },
      "evidenceHashes": {
        "feasibilityReport": "fnv1a32-5b0df6f9",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
        "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
        "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
        "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
        "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "spaceEnvironmentEvidenceLedger": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
        "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
        "sourceQueryCustodyLedger": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
        "customerReadinessContract": "sha256-af2fd31db2e74998866192ad6e50e6f6f113fa06c30f185583d9ca527451472f",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "sidecarScaffoldRejectionLedger": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
        "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
        "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
        "includedArtifacts": "sha256-0ce10bcc41ec6b23edf761c5d87c38b58e957642116cf42cb757a18e3aefe564"
      },
      "reviewRequired": [
        "taxonomy/spectra evidence review",
        "candidate-specific source review"
      ],
      "blockers": [
        "Claim promotion safe: 2 workspace claims remain unverified or blocked.",
        "Runtime sidecar validation: No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted.",
        "No runtime sidecar artifact has promoted; mission-design claims remain blocked.",
        "Customer readiness proof gate is blocked: source-use-rights.",
        "Customer readiness proof gate is blocked: runtime-sidecars.",
        "Customer readiness proof gate is blocked: model-validation.",
        "Customer readiness proof gate is blocked: resource-candidates.",
        "Customer readiness proof gate is blocked: economics.",
        "Customer readiness proof gate is blocked: materials-process.",
        "Customer readiness proof gate is blocked: workspace-review.",
        "Model validation protocols still have blocked commercial-use gates.",
        "Materials/process records still lack promoted material payloads and runtime physics artifacts."
      ],
      "allowedUse": "Decision-support and diligence package only; not an operational mission design, launch commitment, or verified resource claim.",
      "packageHash": "sha256-168164a372d0887c73fed0a816b44b4ccb4e19bf68111035cb8d7ea47a48a93a"
    },
    {
      "id": "package-science-validation-backlog-v1",
      "title": "Science Validation Backlog Package",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "status": "beta-blocked",
      "deliverableType": "engineering-validation-roadmap",
      "customerQuestion": "Which runtime science artifacts must be generated before trajectory, event-window, or optimization claims can promote?",
      "buyerFit": [
        "internal engineering",
        "scientific advisors",
        "technical diligence reviewers"
      ],
      "workspaceRef": {
        "id": "workspace-science-validation-backlog",
        "title": "Science Validation Backlog",
        "workspaceHash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25",
        "reviewStage": "engineering-validation",
        "blockedGateCount": 2
      },
      "runRefs": [
        {
          "id": "run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "selectedScenarioId": "hybrid",
          "claimState": "model-derived-unvalidated"
        }
      ],
      "includedArtifacts": [
        {
          "id": "artifact-scenario-diligence-work-order-ledger",
          "label": "Scenario diligence work-order ledger",
          "path": "public/scenario-diligence-work-order-ledger.json",
          "hash": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
          "role": "Customer/package-linked diligence work orders, acceptance gates, affected scenarios, replay commands, and decision-delta requirements."
        },
        {
          "id": "artifact-scenario-decision-delta-ledger",
          "label": "Scenario decision delta ledger",
          "path": "public/scenario-decision-delta-ledger.json",
          "hash": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
          "role": "Fail-closed before/after acceptance records proving no diligence work order can change a customer answer without a hashed after-run artifact."
        },
        {
          "id": "artifact-customer-decision-dossier-ledger",
          "label": "Customer decision dossier ledger",
          "path": "public/customer-decision-dossier-ledger.json",
          "hash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
          "role": "Scenario-by-scenario customer-use state, buyer boundary, evidence summary, blockers, proof-to-change-answer, and next proof actions."
        },
        {
          "id": "artifact-model-validation-protocols",
          "label": "Model validation protocol ledger",
          "path": "public/model-validation-protocols.json",
          "hash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
          "role": "Domain-by-domain validation protocols, acceptance criteria, source/runtime gates, blocker states, and commercial-use boundaries."
        },
        {
          "id": "artifact-asteroid-candidate-evidence-ledger",
          "label": "Asteroid candidate evidence ledger",
          "path": "public/asteroid-candidate-evidence-ledger.json",
          "hash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
          "role": "Candidate-level SBDB/CAD/MPC/taxonomy/spectra evidence requirements, blockers, and resource-promotion gates."
        },
        {
          "id": "artifact-candidate-source-promotion-ledger",
          "label": "Candidate source promotion ledger",
          "path": "public/candidate-source-promotion-ledger.json",
          "hash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
          "role": "Candidate work-order source custody, resource-promotion, customer-use gates, report intake state, and explicit work-order gaps."
        },
        {
          "id": "artifact-candidate-source-closure-packets",
          "label": "Candidate source closure packets",
          "path": "public/candidate-source-closure-packets.json",
          "hash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
          "role": "Executable candidate-by-candidate closure packets with missing MPC, review, composition, and customer-use acceptance gates."
        },
        {
          "id": "artifact-capability-maturity-ledger",
          "label": "Capability maturity ledger",
          "path": "public/capability-maturity-ledger.json",
          "hash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
          "role": "Business capability maturity, source coverage, model coverage, sidecar blockers, and commercialization gates."
        },
        {
          "id": "artifact-claim-evidence-ledger",
          "label": "Claim evidence ledger",
          "path": "public/claim-evidence-ledger.json",
          "hash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
          "role": "Claim-level source coverage, confidence, promotion gates, allowed use, and blockers."
        },
        {
          "id": "artifact-feasibility-report",
          "label": "Canonical feasibility report",
          "path": "public/feasibility-report.json",
          "hash": "fnv1a32-5b0df6f9",
          "role": "Executive scenario comparison and governance summary."
        },
        {
          "id": "artifact-model-run-ledger",
          "label": "Versioned model-run ledger",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
          "role": "Reproducible run inputs, uncertainty settings, rankings, and run hashes."
        },
        {
          "id": "artifact-model-run-comparison-ledger",
          "label": "Model-run comparison ledger",
          "path": "public/model-run-comparison-ledger.json",
          "hash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
          "role": "Run-to-run selected-scenario, rank-one, utility, uncertainty, business-readiness, and replay-boundary deltas."
        },
        {
          "id": "artifact-assumption-impact-ledger",
          "label": "Assumption impact ledger",
          "path": "public/assumption-impact-ledger.json",
          "hash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
          "role": "Assumption-to-scenario sensitivity, source coverage, stress behavior, and promotion gates."
        },
        {
          "id": "artifact-scenario-comparison-board",
          "label": "Scenario comparison board",
          "path": "public/scenario-comparison-board.json",
          "hash": "sha256-0e1eace128cfbc59ff9ab66a05bee97e637f3afe3a0990327886d7e717be0c48",
          "role": "Business-grade scenario comparison board with decision score, uncertainty budget, economics, traceability, blockers, and CSV/Markdown export hashes."
        },
        {
          "id": "artifact-scenario-notebook-pack",
          "label": "Scenario notebook pack",
          "path": "public/scenario-notebook-pack.json",
          "hash": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
          "role": "Scenario-by-scenario reviewer notebooks with source coverage, open questions, blockers, work orders, and Markdown export hashes."
        },
        {
          "id": "artifact-runtime-validation-campaign-ledger",
          "label": "Runtime validation campaign ledger",
          "path": "public/runtime-validation-campaign-ledger.json",
          "hash": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
          "role": "Campaign-by-campaign runtime closure plan for SPICE, Orekit, GMAT, Tudat, and OpenMDAO/Dymos evidence promotion."
        },
        {
          "id": "artifact-runtime-closure-packet",
          "label": "Runtime closure packet",
          "path": "public/runtime-closure-packet.json",
          "hash": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
          "role": "Operator-grade runtime closure packet with setup custody, commands, intake reports, acceptance checks, and fail-closed release impact."
        },
        {
          "id": "artifact-trajectory-validation-matrix",
          "label": "Trajectory validation matrix",
          "path": "public/trajectory-validation-matrix.json",
          "hash": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
          "role": "Decision-facing SPICE/Orekit/GMAT/Tudat validation matrix with current evidence state, independent-comparison requirements, residual frontier blockers, and scenario decision links."
        },
        {
          "id": "artifact-trajectory-residual-acceptance-ledger",
          "label": "Trajectory residual acceptance ledger",
          "path": "public/trajectory-residual-acceptance-ledger.json",
          "hash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
          "role": "Fail-closed cross-tool residual acceptance lanes for Orekit/GMAT/Tudat/SPICE comparisons before trajectory evidence can affect scenario rankings."
        },
        {
          "id": "artifact-source-use-clearance-dossier",
          "label": "Source-use clearance dossier",
          "path": "public/source-use-clearance-dossier.json",
          "hash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
          "role": "Customer/commercial source-use clearance workflow by source class, required approvals, redistribution boundaries, and fail-closed report-use decisions."
        },
        {
          "id": "artifact-scenario-decision-audit-ledger",
          "label": "Scenario decision audit ledger",
          "path": "public/scenario-decision-audit-ledger.json",
          "hash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
          "role": "Scenario-by-scenario explanation of ranking drivers, flip conditions, assumption sensitivities, validation protocol refs, and proof burdens."
        },
        {
          "id": "artifact-scenario-crossover-frontier",
          "label": "Scenario crossover frontier",
          "path": "public/scenario-crossover-frontier.json",
          "hash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
          "role": "Pairwise scenario utility gaps and explicit threshold paths showing what assumptions would need to change for a challenger scenario to win."
        },
        {
          "id": "artifact-scenario-uncertainty-budget-ledger",
          "label": "Scenario uncertainty budget ledger",
          "path": "public/scenario-uncertainty-budget-ledger.json",
          "hash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
          "role": "Scenario-by-scenario decomposition of modeled uncertainty, assumption blockers, runtime gaps, source-use risk, economics evidence, and resource ambiguity."
        },
        {
          "id": "artifact-scenario-decision-ledger",
          "label": "Scenario decision ledger",
          "path": "public/scenario-decision-ledger.json",
          "hash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "role": "Weighted driver decomposition, uncertainty, economics, blockers, and decision lane for every scenario."
        },
        {
          "id": "artifact-scenario-traceability-matrix",
          "label": "Scenario traceability matrix",
          "path": "public/scenario-traceability-matrix.json",
          "hash": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
          "role": "Scenario-by-scenario trace from rankings to assumptions, claims, sources, model runs, runtime sidecars, and blockers."
        },
        {
          "id": "artifact-evidence-gap-priority-ledger",
          "label": "Evidence gap priority ledger",
          "path": "public/evidence-gap-priority-ledger.json",
          "hash": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
          "role": "Ranked closure backlog for source, runtime, economics, resource, traceability, and release evidence gaps."
        },
        {
          "id": "artifact-promotion-closure-ledger",
          "label": "Promotion closure ledger",
          "path": "public/promotion-closure-ledger.json",
          "hash": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
          "role": "Executable closure plans for blocked science, resource, economics, materials, and model-validation promotion gates."
        },
        {
          "id": "artifact-economics-frontier",
          "label": "Economics frontier report",
          "path": "public/economics-frontier.json",
          "hash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
          "role": "Seeded economics Monte Carlo, rank stability, funding coverage, and promotion blockers."
        },
        {
          "id": "artifact-economics-evidence-ledger",
          "label": "Economics evidence ledger",
          "path": "public/economics-evidence-ledger.json",
          "hash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
          "role": "Dated economics source surfaces, normalization requirements, model input references, and promotion gates."
        },
        {
          "id": "artifact-materials-process-evidence-ledger",
          "label": "Materials/process evidence ledger",
          "path": "public/materials-process-evidence-ledger.json",
          "hash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
          "role": "Process-by-process material property requirements, source references, scenario fit links, runtime artifact gaps, and promotion gates."
        },
        {
          "id": "artifact-space-environment-evidence-ledger",
          "label": "Space environment evidence ledger",
          "path": "public/space-environment-evidence-ledger.json",
          "hash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
          "role": "SPDF/CDAWeb, CCMC, SWPC, DTN, and CCSDS source requirements, scenario stress links, runtime artifact gaps, and promotion gates."
        },
        {
          "id": "artifact-sidecar-readiness-ledger",
          "label": "Runtime sidecar readiness ledger",
          "path": "public/sidecar-readiness-ledger.json",
          "hash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
          "role": "Contract-by-contract runtime readiness, promoted artifacts, blocked prerequisites, preflight evidence, command templates, and next actions."
        },
        {
          "id": "artifact-workspace-ledger",
          "label": "Research workspace ledger",
          "path": "public/workspace-ledger.json",
          "hash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
          "role": "Project/workspace binding for runs, claims, assumptions, notebooks, and review gates."
        },
        {
          "id": "artifact-model-artifacts",
          "label": "Model artifact bundle",
          "path": "public/model-artifacts.json",
          "hash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "role": "Source-backed model artifact records and promotion blockers."
        },
        {
          "id": "artifact-source-refresh",
          "label": "Source refresh evidence report",
          "path": "public/source-refresh-report.json",
          "hash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "role": "Snapshot-first source refresh plan and review candidate checks."
        },
        {
          "id": "artifact-source-ingestion-ledger",
          "label": "Source ingestion work-order ledger",
          "path": "public/source-ingestion-ledger.json",
          "hash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
          "role": "Source-by-source ingestion contracts, required payload hashes, normalization gates, and promotion blockers."
        },
        {
          "id": "artifact-source-use-rights-ledger",
          "label": "Source use-rights ledger",
          "path": "public/source-use-rights-ledger.json",
          "hash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "role": "Source-by-source terms, citation, redistribution, provider-endorsement, and customer-use review gates."
        },
        {
          "id": "artifact-source-use-review-packets",
          "label": "Source use review packets",
          "path": "public/source-use-review-packets.json",
          "hash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
          "role": "Per-source review packets for terms/license capture, citation approval, redistribution decisions, provider-endorsement boundaries, and customer-use approval."
        },
        {
          "id": "artifact-source-query-custody-ledger",
          "label": "Source query custody ledger",
          "path": "public/source-query-custody-ledger.json",
          "hash": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
          "role": "Provider query contracts, parser boundaries, unit maps, uncertainty maps, legal notes, and non-promotion rules for live source refresh candidates."
        },
        {
          "id": "artifact-sidecar-validation",
          "label": "Science sidecar validation gate",
          "path": "public/sidecar-validation-report.json",
          "hash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
          "role": "Fail-closed intake gate for SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts."
        },
        {
          "id": "artifact-sidecar-work-orders",
          "label": "Science sidecar execution packet",
          "path": "public/sidecar-work-orders.json",
          "hash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
          "role": "Executable work orders for external SPICE/Orekit/GMAT/Tudat/OpenMDAO workers."
        },
        {
          "id": "artifact-sidecar-run-specs",
          "label": "Science sidecar run specifications",
          "path": "public/sidecar-run-specs.json",
          "hash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
          "role": "Hash-backed execution specs, required inputs, acceptance gates, and non-evidence boundaries for external science workers."
        },
        {
          "id": "artifact-sidecar-artifact-templates",
          "label": "Science sidecar artifact templates",
          "path": "public/sidecar-artifact-templates.json",
          "hash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
          "role": "Fail-closed JSON templates showing the exact output shape external science workers must fill before sidecar intake."
        },
        {
          "id": "artifact-sidecar-scaffold-rejection-ledger",
          "label": "Science sidecar scaffold rejection ledger",
          "path": "public/sidecar-scaffold-rejection-ledger.json",
          "hash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
          "role": "Hash-backed proof that Orekit, GMAT, and Tudat beta scaffolds are contract-traceable and intentionally blocked from promotion."
        },
        {
          "id": "workspace-workspace-science-validation-backlog",
          "label": "Science Validation Backlog",
          "path": "public/workspace-ledger.json",
          "hash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25",
          "role": "Workspace-specific project, decision gate, review gates, and evidence hashes."
        },
        {
          "id": "run-run-hybrid-base-2026-06-19",
          "label": "Hybrid base feasibility run",
          "path": "public/model-run-ledger.json",
          "hash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "role": "Model run selected scenario: hybrid."
        }
      ],
      "customerReadinessContract": {
        "state": "customer-beta-blocked",
        "decisionSupportAllowed": true,
        "commercialUseAllowed": false,
        "verifiedClaimIds": [
          "claim-mercury-flux",
          "claim-de440-boundary",
          "claim-dtn"
        ],
        "blockedClaimIds": [
          "claim-helium3",
          "claim-spf-separation",
          "claim-mercury-core"
        ],
        "allowedClaims": [
          "Source-backed beta context claims may be cited only with evidence hashes attached.",
          "Scenario rankings may be used as decision-support heuristics with uncertainty and blocker context visible.",
          "Evidence-gap, crossover, and diligence priorities may be used to scope paid research work."
        ],
        "blockedClaims": [
          "No operational mission design, launch commitment, or flight-dynamics certification.",
          "No asteroid or planetary resource-composition claim without candidate-specific taxonomy, spectra, mission, or sample evidence.",
          "No commercial economics, throughput, process-quality, or manufacturability claim while economics/materials/process ledgers are blocked.",
          "No customer-facing trajectory/event-window claim until the full required runtime set and independent validation gates pass.",
          "No raw source redistribution or customer commercial use until source-use rights review passes."
        ],
        "proofGates": [
          {
            "id": "source-use-rights",
            "label": "Source use rights",
            "status": "blocked",
            "evidenceHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
            "requiredProof": "Terms/license evidence, citation policy, redistribution scope, provider-boundary decision, and reviewer approval for every customer-facing source."
          },
          {
            "id": "runtime-sidecars",
            "label": "Runtime sidecars",
            "status": "blocked",
            "evidenceHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
            "requiredProof": "Current reproducible SPICE/Orekit/GMAT/Tudat/OpenMDAO artifacts promoted through sidecar intake, not only source scaffolds or historical preflight."
          },
          {
            "id": "model-validation",
            "label": "Model validation",
            "status": "blocked",
            "evidenceHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
            "requiredProof": "Domain validation protocols pass with accepted tolerances, independent comparison where required, and reviewer approval."
          },
          {
            "id": "resource-candidates",
            "label": "Resource candidates",
            "status": "blocked",
            "evidenceHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
            "requiredProof": "Candidate-specific SBDB/CAD/MPC/taxonomy/spectra/mission evidence, reviewed source custody, and customer-use clearance before any resource-composition or feedstock claim."
          },
          {
            "id": "economics",
            "label": "Economics evidence",
            "status": "blocked",
            "evidenceHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
            "requiredProof": "Dated launch, delivery, capex, opex, market, and award records normalized into model-ready economics payloads."
          },
          {
            "id": "materials-process",
            "label": "Materials/process evidence",
            "status": "blocked",
            "evidenceHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
            "requiredProof": "Promoted NIST/Materials Project/PDS material records plus Cantera/MOOSE/OpenFOAM or equivalent process artifacts."
          },
          {
            "id": "workspace-review",
            "label": "Workspace review",
            "status": "blocked",
            "evidenceHash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25",
            "requiredProof": "Workspace gates, selected runs, package scope, and reviewer approvals are closed."
          }
        ],
        "blockedProofGateIds": [
          "source-use-rights",
          "runtime-sidecars",
          "model-validation",
          "resource-candidates",
          "economics",
          "materials-process",
          "workspace-review"
        ],
        "currentRuntimePreflight": {
          "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
          "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
          "readyContractIds": [
            "openmdao-dymos-optimization-v1",
            "spice-gf-event-window-v1"
          ],
          "blockedContractIds": [
            "gmat-transfer-v1",
            "orekit-propagation-v1",
            "tudat-transfer-v1"
          ]
        },
        "customerUseBoundary": "This package can support research planning and diligence only; it is not commercial proof until every proof gate is pass.",
        "contractHash": "sha256-b32de2b663893520d61d1c3429c62d9276313a853df0497df6c86f679974ad2b"
      },
      "evidenceHashes": {
        "feasibilityReport": "fnv1a32-5b0df6f9",
        "asteroidCandidateEvidenceLedger": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
        "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
        "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
        "capabilityMaturityLedger": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
        "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
        "workspaceLedger": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
        "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
        "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
        "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
        "scenarioDecisionDeltaLedger": "sha256-f4a173a8bcceded9b5233a16c6183b796691655ee8eb0a41db4532211e6115de",
        "scenarioDiligenceWorkOrderLedger": "sha256-077fc3aa81c911ed7d1383a077ee114465590356ac05749cae6233010c44f92a",
        "scenarioNotebookPack": "sha256-0f0829747839a100054dc1e908300ffa0223fa0e61b8c34a817db361ec67f685",
        "runtimeValidationCampaignLedger": "sha256-7d6f913ac6a611baf6052809984397293a597736628121801cff5135edc9a45b",
        "runtimeClosurePacket": "sha256-67b23b0dec664b27b660c3d364a8613c35e7b87b21141f65e88ed7951a57527d",
        "trajectoryValidationMatrix": "sha256-16cd41ff7950bb20d30207308ae8694f4b5cf91faa31f3323bfe10608f7a4e2e",
        "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
        "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
        "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
        "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
        "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
        "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
        "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
        "promotionClosureLedger": "sha256-d14fdc5117888b18cc4aaf6eabc8c09785595638de06e3cabcdd8cc0f8421f1c",
        "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
        "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
        "materialsProcessEvidenceLedger": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
        "spaceEnvironmentEvidenceLedger": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
        "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "modelValidationProtocols": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sourceIngestionLedger": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
        "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
        "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
        "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
        "sourceQueryCustodyLedger": "sha256-2d6a00b38e1db64ab8719992cf2fd441eaa804e9993a346f8b5ab28d3031de8c",
        "customerReadinessContract": "sha256-b32de2b663893520d61d1c3429c62d9276313a853df0497df6c86f679974ad2b",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
        "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
        "sidecarScaffoldRejectionLedger": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
        "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
        "sidecarRunSpecPacket": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
        "sidecarArtifactTemplatePacket": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86",
        "includedArtifacts": "sha256-e9b0f4b6b6075bbefb3eef2df9bbf5afc375e53e348ec7288776019edf984651"
      },
      "reviewRequired": [
        "SPICE runtime artifact",
        "Orekit/GMAT/Tudat comparison",
        "OpenMDAO/Dymos artifact"
      ],
      "blockers": [
        "Claim promotion safe: 1 workspace claims remain unverified or blocked.",
        "Runtime sidecar validation: No SPICE/Orekit/GMAT/Tudat/OpenMDAO runtime sidecar artifacts have promoted.",
        "No runtime sidecar artifact has promoted; mission-design claims remain blocked.",
        "Customer readiness proof gate is blocked: source-use-rights.",
        "Customer readiness proof gate is blocked: runtime-sidecars.",
        "Customer readiness proof gate is blocked: model-validation.",
        "Customer readiness proof gate is blocked: resource-candidates.",
        "Customer readiness proof gate is blocked: economics.",
        "Customer readiness proof gate is blocked: materials-process.",
        "Customer readiness proof gate is blocked: workspace-review.",
        "Model validation protocols still have blocked commercial-use gates.",
        "Materials/process records still lack promoted material payloads and runtime physics artifacts."
      ],
      "allowedUse": "Decision-support and diligence package only; not an operational mission design, launch commitment, or verified resource claim.",
      "packageHash": "sha256-809457624f360385197843a54d99ec1b3a4ffb3d8f30166c91c8691ac94627e1"
    }
  ],
  "manifestHash": "sha256-acb877a48f3c3f16951cd0ffc3244b627c4fce0084e6eff9ca8a11a0fc37b9fb"
}
;
